import React, { useEffect, useState, useRef } from 'react'
import { createUseStyles, useTheme } from 'react-jss'

import DispatcherService from '../../services/DispatcherService'

import photoFaceValidator from '../../utils/photoFaceValidator'

import Header from '../form/Header'
import View from '../form/View'
import Footer from '../form/Footer'

import { toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import { isMobile } from 'react-device-detect'

const useStyles = createUseStyles(theme => ({
  root: {
    flex: 1,
    height: '100%',
    flexDirection: 'column',
    backgroundColor: '#000',
    '@media(min-width: 1000px)': {
      backgroundColor: '#ffffff',
    }
  },
  onlySmallscreen: {
    flex: 1,
    width: '100%',
    flexDirection: 'column',
    justifyContent: 'flex-end',
    zIndex: 10,
    '@media(min-width: 1000px)': {
      display: 'none'
    }
  },
  title: {
    justifyContent: 'center',
    fontFamily: 'Fira Sans',
    fontStyle: 'normal',
    fontWeight: 'bold',
    color: '#FFFFFF',
    fontSize: '32px',
    '@media(max-height: 976px)': {
      fontSize: '24px',
    },
    marginTop: '90px',
    '@media(min-width: 1000px)': {
      marginTop: '30px'
    }
  },
  countdown: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
    fontFamily: 'Fira Sans',
    fontStyle: 'normal',
    fontWeight: 'bold',
    fontSize: '64px',
    color: '#FFFFFF',
  },
  videoFitWide: {
    width: '747px',
    borderRadius: '8px',
    marginLeft: '-50%',
    '@media(max-height: 976px)': {
      width: '596px'
    }
  },
  canvasFitWide: {
    height: '420px',
    objectFit: 'cover',
    borderRadius: '8px',
    '@media(max-height: 976px)': {
      height: '336px'
    }
  },
  canvasImageWide: {
    width: '350px',
    height: '420px',
    '@media(max-height: 976px)': {
      width: '280px',
      height: '336px'
    },
    position: 'absolute',
    margin: 'auto',
    top: 0,
    bottom: 0,
    borderRadius: '8px',
    transform: 'scale(-1, 1)'
  },
  cameraImageWide: {
    width: '350px',
    height: '420px',
    '@media(max-height: 976px)': {
      width: '280px',
      height: '336px'
    },
    position: 'absolute',
    margin: 'auto',
    top: 0,
    bottom: 0,
    borderRadius: '8px',
    overflow: 'hidden',
    display: 'block',
    transform: 'scale(-1, 1)'
  },
  videoFitMobile: {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
    transform: 'scale(-1, 1)'
  },
  canvasFitMobile: {
    width: '100%',
    height: '100%',
    objectFit: 'cover'
  },
  mediaArea: {
    flex: 1,
    '@media(min-width: 1000px)': {
      flex: 1,
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      position: 'relative',
      boxSizing: 'border-box',
      borderRadius: '8px',
      margin: '0 36px 10px',
      padding: '0 32px',
      cursor: 'pointer'
    }
  },
  onlyWidescreen: {
    display: 'none',
    '@media(min-width: 1000px)': {
      display: 'flex',
      zIndex: 10,
    }
  },
  block: {
    display: 'block'
  },
  widescreenCountdown: {
    flex: 1,
    flexDirection: 'column',
    justifyContent: 'flex-start'
  },
  silhouetteWide: {
    position: 'absolute',
    maxWidth: '180%',
    maxHeight: '130%',
    top: '50%',
    left: '50%',
    borderRadius: '8px',
    transform: 'translate(-50%, -50%)',
    width: '350px',
    height: '420px',
    '@media(max-height: 976px)': {
      width: '280px',
      height: '336px'
    }
  },
  cameraImageMobile: {
    position: 'absolute',
    top: 0,
    bottom: 0,
    width: '100%'
  },
  silhouetteMobile: {
    width: '100%',
    position: 'absolute',
    top: '0',
    left: '0'
  },
  nextStyles: {
    backgroundColor: '#1A8927',
    color: 'white'
  },
  backStyles: {
    borderWidth: 0,
    backgroundColor: '#DD3416',
    color: 'white'
  }
}))

function CameraView (props) {
  
  const theme = useTheme()
  const styles = useStyles({ ...props, theme })
  const [ cameraImage, setCameraImage ] = useState(null)

  const [ counter, setCounter ] = useState(null)
  const countdown = DispatcherService.isCountdownEnabled()

  const [ labelPhoto, setLabelPhoto ] = useState('Tirar Foto')

  const photoScore = DispatcherService.getPhotoScore()

  const refCanvasElement = useRef(null)
  const refVideoElement = useRef(null)

  const resolutions = {
    480 : { cropSizeWidth: 94,  canvasWidth: 398 },
    720 : { cropSizeWidth: 300, canvasWidth: 600 }
  };

  toast.configure()

  function showMessage(message, id, autoClose, onClose){
    toast.info(message, {
        toastId: id,
        position: "top-center",
        autoClose: autoClose,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        onClose: () => {
            onClose && onClose()
        }
    });
  }

  useEffect(() => {
    if (refVideoElement && refVideoElement.current) {
        refVideoElement.current.srcObject = props.mediaStream
    }
  }, [ refVideoElement, props.mediaStream, cameraImage ])

  useEffect(() => {

    if(!props.mediaStream){
        return;
    }
    
    let timeoutFn = null
    
    if (counter > 0) {
        timeoutFn = setTimeout(() => setCounter(counter - 1), 1000)
    } else if (countdown && counter === 0) {
        takePhoto()
    }

    return () => {
        if (timeoutFn) {
            clearTimeout(timeoutFn)
        }
    }

  }, [ counter ])

  let blockPhoto = false;

  const takePhoto = async () => {

    if(blockPhoto){
        return;
    }

    blockPhoto = true;
    setLabelPhoto('Aguarde')

    const videoElement = refVideoElement.current
    const width = videoElement.videoWidth
    const height = videoElement.videoHeight

    const canvas = refCanvasElement.current

    if(isMobile){

      canvas.width = width
      canvas.height = height   
      const context = canvas.getContext('2d')
      context.drawImage(videoElement, 0, 0, width, height)

    } else { 
      
      canvas.width = resolutions[height].canvasWidth
      canvas.height = height   
      
      const cropSizeWidth = resolutions[height].cropSizeWidth;
      const finalCroppedWidth = width - cropSizeWidth;
    
      const context = canvas.getContext('2d')
      context.drawImage(videoElement, cropSizeWidth, 0, finalCroppedWidth, height, 0, 0, finalCroppedWidth, height)
    
    }
    
    const isValidatePhoto = (photoScore !== undefined && photoScore === '0') ? false : true

    if (isValidatePhoto) {

      const faceBoxHeight = DispatcherService.getFaceBoxHeight()
      const faceBoxWidth = DispatcherService.getFaceBoxWidth()

      const isValid = await photoFaceValidator.validate(canvas, photoScore, faceBoxHeight, faceBoxWidth)

      if(isValid) {
        canvas.toBlob(blob => setCameraImage(blob), 'image/jpeg')
      } else {
        showMessage("Foto inválida, tente novamente encaixando o rosto na marcação.", "invalid-photo-message", 5000);
      }

    } else {
      canvas.toBlob(blob => setCameraImage(blob), 'image/jpeg')
    }

    setLabelPhoto('Tirar Foto')
    blockPhoto =false;

  }

  const startCountdown = () => {
    setCounter(3)
  }

  const cancelCountdown = () => {
    if (counter) {
      setCounter(null)
    } else {
      props.onCancel()
    }
  }

  const cancelPhoto = () => {
    props.onCancel()
  }

  const confirmCameraImage = () => {
    props.onCameraImage(cameraImage)
  }

  const clearCameraImage = () => {
    setCameraImage(null)
  }

  return (
    <View className={styles.root}>
      <View className={styles.onlyWidescreen}>
        <Header 
          title={props.title} 
          index={props.index} 
          numOfSteps={props.numOfSteps} 
          showMarkers={true}
        />
      </View>
      
      <View className={styles.mediaArea}>
        <div className={props.isMobile ? styles.cameraImageMobile : styles.canvasImageWide} hidden={!cameraImage}> 
          <canvas ref={refCanvasElement} className={props.isMobile ? styles.canvasFitMobile : styles.canvasFitWide}></canvas>
        </div>
        { !cameraImage && (
          <div className={props.isMobile ? styles.cameraImageMobile : styles.cameraImageWide}>
            <video 
              autoPlay 
              playsInline 
              ref={refVideoElement} 
              className={props.isMobile ? styles.videoFitMobile : styles.videoFitWide}
            ></video>
            <img 
                className={props.isMobile ? styles.silhouetteMobile : styles.silhouetteWide} 
                alt="TOPTIC GO" 
                src={ props.isMobile ? require('../../assets/silhueta_mobile.png') : require('../../assets/silhueta_wide.png')}
            />
          </div>
        )}
        { !!counter && (
          <View className={`${styles.onlyWidescreen} ${styles.widescreenCountdown}`}>
            <View className={styles.title}>
              Prepare-se para a foto
            </View>
            <View className={styles.countdown}>
              { counter }
            </View>
          </View>
          )}
      </View>

      <View className={`${styles.onlyWidescreen} ${styles.block}`}>
        {!cameraImage ? (
          <Footer
            backLabel={counter ? 'Cancelar' : 'Voltar'}
            nextLabel={labelPhoto}
            onBack={countdown ? cancelCountdown : cancelPhoto}
            onNext={countdown ? startCountdown : takePhoto}
            disabled={counter || cameraImage}
          />
        ) : (
          <Footer
            backLabel='Tentar novamente'
            nextLabel='Confirmar'
            onBack={clearCameraImage}
            onNext={confirmCameraImage}
            disabled={false} 
          />
        )}
      </View>
      <View className={styles.onlySmallscreen}>
        { !!counter && (
            <View className={styles.onlySmallscreen}>
              <View className={styles.title}>
                Prepare-se para a foto
              </View>
              <View className={styles.countdown}>
                { counter }
              </View>
            </View>
          )}
        { !cameraImage ? (
          <Footer
            backLabel={counter ? 'Cancelar' : 'Voltar'}
            backStyles={styles.backStyles}
            nextLabel= {labelPhoto}
            nextStyles={styles.nextStyles}
            onBack={countdown ? cancelCountdown : cancelPhoto}
            onNext={countdown ? startCountdown : takePhoto}
            disabled={counter || cameraImage}
          />
        ) : (
          <Footer 
            backLabel='Tentar novamente'
            backStyles={styles.backStyles}
            nextLabel='Confirmar'
            nextStyles={styles.nextStyles}
            onBack={clearCameraImage}
            onNext={confirmCameraImage}
            disabled={false} 
          />
        )}
      </View>
    </View>
  ) 
}

export default CameraView